(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/expired', {
      templateUrl: 'modules/outside/expired/expired.html'
    });
  }]);
})();
